import { envConfig } from "config";
import packageJson from "package.json";

const pv = packageJson.version;

const resolveCdn = (filePath) => {
  if (!filePath || process.env.NODE_ENV === "development") {
    return filePath ? `${filePath}?pv=${pv}` : null;
  }

  const { cdn } = envConfig;

  return `${cdn}${filePath}?pv=${pv}`;
};

export default resolveCdn;
